module.exports = __webpack_public_path__ + "media/introduce.0da24344.mp4";